import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Sidemenu from '../base/sidemenu';
import { useNavigate } from "react-router-dom";
import "./DepartmentPlusRedesign.css";
export default function Department() {
  const [departments, setDepartments] = useState([]);
  const [newDept, setNewDept] = useState('');
  const [editDeptId, setEditDeptId] = useState(null);
  const [editDeptName, setEditDeptName] = useState('');

  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  // 목록 불러오기
  const fetchDepartments = async () => {
   
    const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/department`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    setDepartments(res.data.department || res.data);
  };

  useEffect(() => { fetchDepartments(); }, []);

  // 추가
  const handleAdd = async () => {
  if (!newDept.trim()) return alert("소속명을 입력해주세요.");
  try {
    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/department`, { name: newDept }, {
      headers: { Authorization: `Bearer ${token}` }
    });
    if (response.data.success === false) {
      alert(response.data.message);
      return;
    }
    alert(response.data.message);
    setNewDept('');
    fetchDepartments();
  } catch (error) {
    console.error(error);
    alert("추가 중 오류가 발생했습니다.");
  }
};
  // 수정
  const handleEdit = async (id) => {
    try {
      const response = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/department`, {
        id,
        name: editDeptName
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
  
      if (response.data.success === false) {
        alert(response.data.message);
        return;
      }
      alert(response.data.message);
      setEditDeptId(null);
      setEditDeptName('');
      fetchDepartments();
    } catch (error) {
      console.error(error);
      alert("수정 중 오류가 발생했습니다.");
    }
  };
  
  

  // 삭제
  const handleDelete = async (id) => {
    if (!window.confirm("삭제하시겠습니까?")) return;
    try {
      const response = await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/department/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
  
      if (response.data.success === false) {
        alert(response.data.message);
        return;
      }
      alert(response.data.message);  
      fetchDepartments();
    } catch (error) {
      console.error(error);
      alert("삭제 중 오류가 발생했습니다.");
    }
  };
  

return (
  <div className="flex department-redesign-layout">
    <Sidemenu />

    <main className="department-redesign-content">
      <div className="dp-page">
        <div className="dp-top">
          <button className="dp-back" onClick={() => navigate("/admin")}>
            ← 관리자 목록
          </button>
        </div>

        <div className="dp-heading">
          <h2>소속 관리</h2>
          <p>관리자 계정에 사용할 소속 정보를 등록하고 관리할 수 있습니다.</p>
        </div>

        <section className="dp-card">
          <div className="dp-card-title">
            <h3>소속 등록</h3>
            <span>새로운 소속을 추가할 수 있습니다.</span>
          </div>

          <div className="dp-add-row">
            <input
              type="text"
              value={newDept}
              onChange={e => setNewDept(e.target.value)}
              onKeyDown={e => {
                if (e.key === "Enter" && !e.nativeEvent.isComposing) {
                  handleAdd();
                }
              }}
              placeholder="새 소속명을 입력하세요."
            />
            <button className="dp-primary" onClick={handleAdd}>
              소속 추가
            </button>
          </div>
        </section>

        <section className="dp-card">
          <div className="dp-card-title">
            <h3>소속 목록</h3>
            <span>등록된 소속 정보를 수정하거나 삭제할 수 있습니다.</span>
          </div>

          <div className="dp-table-wrap">
            <table className="dp-table">
              <colgroup>
                <col style={{ width: "10%" }} />
                <col style={{ width: "60%" }} />
                <col style={{ width: "18%" }} />
                <col style={{ width: "12%" }} />
              </colgroup>

              <thead>
                <tr>
                  <th scope="col">번호</th>
                  <th scope="col">소속명</th>
                  <th scope="col">수정</th>
                  <th scope="col">삭제</th>
                </tr>
              </thead>

              <tbody>
                {departments.map((dept, index) => (
                  <tr key={dept.id}>
                    <td>{index + 1}</td>

                    <td className="dp-dept-name">
                      {editDeptId === dept.id ? (
                        <input
                          type="text"
                          value={editDeptName}
                          onChange={e => setEditDeptName(e.target.value)}
                          onKeyDown={e => {
                            if (e.key === "Enter" && !e.nativeEvent.isComposing) {
                              handleEdit(dept.id);
                            }
                          }}
                        />
                      ) : (
                        dept.name
                      )}
                    </td>

                    <td>
                      {editDeptId === dept.id ? (
                        <div className="dp-row-actions">
                          <button
                            className="dp-save"
                            onClick={() => handleEdit(dept.id)}
                          >
                            저장
                          </button>
                          <button
                            className="dp-cancel"
                            onClick={() => {
                              setEditDeptId(null);
                              setEditDeptName("");
                            }}
                          >
                            취소
                          </button>
                        </div>
                      ) : (
                        <button
                          className="dp-edit"
                          onClick={() => {
                            setEditDeptId(dept.id);
                            setEditDeptName(dept.name);
                          }}
                        >
                          수정
                        </button>
                      )}
                    </td>

                    <td>
                      <button
                        className="dp-delete"
                        onClick={() => handleDelete(dept.id)}
                      >
                        삭제
                      </button>
                    </td>
                  </tr>
                ))}

                {departments.length === 0 && (
                  <tr>
                    <td colSpan={4} className="dp-empty">
                      등록된 소속이 없습니다.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="dp-bottom">
            총 <strong>{departments.length}</strong>개 소속
          </div>
        </section>

        <div className="dp-actions">
          <button
            className="dp-secondary"
            onClick={() => navigate("/admin")}
          >
            확인 · 목록으로
          </button>
        </div>
      </div>
    </main>
  </div>
);

}
